export function shortNumber(number) {
    if (number) {
        const abs = Math.abs(number);
        if (abs >= Math.pow(10, 12)) {
            // trillion
            return (number / Math.pow(10, 12)).toFixed(1) + "T";
        } else if (abs < Math.pow(10, 12) && abs >= Math.pow(10, 9)) {
            // billion
            return (number / Math.pow(10, 9)).toFixed(1) + "B";
        } else if (abs < Math.pow(10, 9) && abs >= Math.pow(10, 6)) {
            // million
            return (number / Math.pow(10, 6)).toFixed(1) + "M";
        } else if (abs < Math.pow(10, 6) && abs >= Math.pow(10, 3)) {
            // thousand
            return (number / Math.pow(10, 3)).toFixed(1) + "K";
        }
        return number.toString();
    }
    return number;
}

// Function to check if the token is expired
export const isTokenExpired = (token) => {
    if (!token) return true; // No token means expired
    try {
      // Decode JWT payload (Base64URL decoding)
      const payload = JSON.parse(
        decodeURIComponent(
          atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))
            .split('')
            .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
        )
      );
  
      // Check expiration time
      return Date.now() >= payload.exp * 1000; // Convert exp to milliseconds
    } catch (e) {
      // If decoding or parsing fails, consider the token invalid/expired
      return true;
    }
  };
  